<template>
  <Card class="card-startup" :link="url">
    <div slot="header">
      <b-row>
        <b-col>
          <div
            class="card-logo"
            :style="
              startup.logoImage
                ? {
                    backgroundImage:
                      'url(' + startup.logoImage.thumbnailSizeUrl + ')'
                  }
                : {}
            "
          ></div>
        </b-col>
        <b-col cols="auto">
          <StartupsFollow :startup="startup" @toggle="toggleFollow" />
        </b-col>
      </b-row>
      <h4 slot class="card-title">{{ startup.name }}</h4>
    </div>

    <div class="card-content" v-html="startup.whatWeDo"></div>

    <div slot="footer">
      <div class="card-footer-region">
        <BulletInlineList class="text-gray-700">
          <span v-if="formattedIndustriesText">{{
            formattedIndustriesText
          }}</span>
        </BulletInlineList>
      </div>
      <div class="card-labels">
        <div
          v-if="user && user.isAdmin && startup.views.week > 0"
          class="card-label"
        >
          {{ startup.formattedViews.week }}
        </div>
        <div v-if="startup.numberOfActiveJobs > 0" class="card-label">
          {{ startup.formattedJobCount }}
        </div>
      </div>
    </div>
  </Card>
</template>

<script>
import Card from '@/components/Card'
import BulletInlineList from '@/components/BulletInlineList'
import StartupsFollow from './StartupsFollow'

export default {
  name: 'StartupsCard',
  components: {
    Card,
    BulletInlineList,
    StartupsFollow
  },
  props: {
    startup: {
      type: Object,
      required: true
    }
  },
  computed: {
    user() {
      return this.$store.state.user.data
    },
    url() {
      if (this.$route.path.includes('/client')) {
        return (
          '/client/investors/' + this.$route.params.investor + this.startup.url
        )
      }

      return this.startup.url
    },
    formattedIndustriesText() {
      if (!this.startup.industries) {
        return
      }

      const industries = this.startup.industries.map((industry) =>
        this.$store.getters['meta/industryByValue'](industry)
      )

      return industries.map((industry) => industry.label).join(', ')
    }
  },
  methods: {
    async toggleFollow(value) {
      try {
        await this.$store.dispatch('startups/follow', {
          startup: this.startup,
          value
        })

        if (value) {
          this.$engagement({
            type: 'startup.follow'
          })
        }
      } catch (err) {
        console.error(err)
      }
    }
  }
}
</script>

<style lang="scss">
.card-startup {
  height: 100%;

  .card-logo {
    height: rem(72px);
    width: rem(72px);
    background-position: center center;
    background-repeat: no-repeat;
    background-size: cover;
    margin-bottom: rem(32px);
  }

  .card-title {
    padding: 0 0 rem(14px) 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .card-content {
    margin-bottom: rem(24px);
    font-size: rem(14px);
    color: $gray-700;
    line-height: 1.5;
    height: rem(84px);
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
  }

  .card-footer-category {
    font-weight: bold;
    font-size: rem(16px);
  }

  .card-footer-region {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .card-labels {
    display: flex;
    margin-top: rem(10px);
    .card-label {
      display: inline-block;
      color: $blue-900;
      font-weight: 700;
      background-color: transparentize($blue-900, 0.9);
      padding: rem(6px) rem(14px);
      flex: 0 0 auto;
      & + .card-label {
        margin-left: rem(10px);
      }
    }
  }

  .bullet-inline-list {
    overflow: hidden;

    span {
      color: $gray-900;
      font-weight: 500;
      display: inline-block;
      vertical-align: middle;
      max-width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
</style>
